import { Link } from "react-router-dom";
import {
  formatWarehouseItemDimensions,
  getWarehouseItemFromRow,
} from "./warehouseItemColumnValues";

const cellClassName =
  "overflow-hidden text-ellipsis text-base font-medium leading-5 text-black";

const InstanceReference = ({ values }) => {
  const { instance } = getWarehouseItemFromRow(values) || {};
  if (!instance?.id) return null;

  return (
    <Link
      className={`${cellClassName} underline`}
      title={instance.name}
      to={`/instance/${instance.id}/details`}
    >
      {instance.name}
    </Link>
  );
};

const Dimensions = ({ values }) => {
  const dimensions = formatWarehouseItemDimensions(
    getWarehouseItemFromRow(values),
  );

  return (
    <div className={cellClassName} title={dimensions}>
      {dimensions}
    </div>
  );
};

const ContainerLink = ({ values }) => {
  const { container } = getWarehouseItemFromRow(values) || {};
  if (!container) return null;

  return (
    <Link
      className={`${cellClassName} underline`}
      to={`/warehouse/${container}/details`}
    >
      {container}
    </Link>
  );
};

export { ContainerLink, Dimensions, InstanceReference };
